import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconPanelImages = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M28 6v20H4V6h24zM4 4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4zm7.932 6.339a1 1 0 0 1 1.217.041l6.607 5.431a1 1 0 1 1-1.271 1.545l-6.014-4.944-8.916 6.38a1 1 0 0 1-1.164-1.626l9.54-6.827zm10.479 3.101a.999.999 0 0 1 1.229.034l6.022 4.966a1 1 0 1 1-1.273 1.543l-5.42-4.47-8.336 6.14a.999.999 0 1 1-1.186-1.61l8.964-6.603z"
	})
});
export { SvgIconPanelImages as ReactComponent };
